<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="toc"><a id="page_v"></a><a href="#/xhtml/07_Preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/08_Acknowledgement">Acknowledgments</a></p>
<p class="toca"><a href="#/xhtml/09_Part01"><span class="small">PART ONE</span>: <span class="small">OVERVIEW</span></a></p>
<p class="toc1"><a href="#/xhtml/11_Chapter01">1.  The Haitian Revolution</a></p>
<p class="toca"><a href="#/xhtml/12_Part02"><span class="small">PART TWO</span>: <span class="small">HISTORIOGRAPHY AND SOURCES</span></a></p>
<p class="toc1"><a href="#/xhtml/13_Chapter02">2.  New Approaches and Old</a></p>
<p class="toc1"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3.  Underexploited Sources</span></p>
<p class="toca"><span href="#/xhtml/15_Part03" title="Link target outside of Sample"><span class="small">PART THREE</span>: <span class="small">THE SEEDS OF REVOLT</span></span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter04" title="Link target outside of Sample">4.  The Causation of Slave Rebellions: An Overview</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter05" title="Link target outside of Sample">5.  Marronage, Vodou, and the Slave Revolt of 1791</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter06" title="Link target outside of Sample">6.  The Bois Caïman Ceremony</span></p>
<p class="toca"><span href="#/xhtml/19_Part04" title="Link target outside of Sample"><span class="small">PART FOUR</span>: <span class="small">SLAVES AND FREE COLOREDS</span></span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter07" title="Link target outside of Sample">7.  The “Swiss” and the Problem of Slave/Free Colored Cooperation</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter08" title="Link target outside of Sample">8.  The “Volte-Face” of Toussaint Louverture</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter09" title="Link target outside of Sample">9.  Slave, Soldier, Rebel: The Strange Career of Jean Kina</span></p>
<p class="toca"><span href="#/xhtml/23_Part05" title="Link target outside of Sample"><span class="small">PART FIVE</span>: <span class="small">THE WIDER REVOLUTION</span></span></p>
<p class="toc"><span href="#/xhtml/24_Chapter10" title="Link target outside of Sample">10.  Racial Equality, Slavery, and Colonial Secession during the Constituent Assembly</span></p>
<p class="toc"><span href="#/xhtml/25_Chapter11" title="Link target outside of Sample">11.  The Great Powers and the Haitian Revolution</span></p>
<p class="toc"><span href="#/xhtml/26_Chapter12" title="Link target outside of Sample">12.  The Slave Leaders in Exile: Spain’s Resettlement of Its Black Auxiliary Troops</span></p>
<p class="toca"><span href="#/xhtml/27_Part06" title="Link target outside of Sample"><span class="small">PART SIX</span>: <span class="small">EPILOGUE</span></span></p>
<p class="toc"><span href="#/xhtml/28_Chapter13" title="Link target outside of Sample">13.  The Naming of Haiti</span></p>
<p class="toct"><span href="#/xhtml/29_BM01" title="Link target outside of Sample">Chronology</span></p>
<p class="toc"><span href="#/xhtml/30_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/31_Reference" title="Link target outside of Sample">Works Cited</span></p>
<p class="toc"><span href="#/xhtml/32_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?c4d7295e